import { Outlet, useMatches } from "react-router-dom";
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Err404 } from "@/pages/404";
import { BusyIndicator } from "@/components/BusyIndicator";
import { Profile } from "@/pages/profile/Profile";
import { Login } from "@/pages/auth/Login";
import { Signup } from "@/pages/auth/Signup";
import { ResetPassword } from "@/pages/auth/ResetPassword";
import { CreateNewPassword } from "@/pages/auth/CreateNewPassword";
import { routes } from "./Routes";
import NavigationHandler from "@/components/NavigationHandler";
import { interactionStore, authStore } from "@/stores/Stores";
import { authService } from "@/services/Services";
import { User } from "@/models/User";
import { getCookie } from "@/util/cookieUtils";

const BrowserRoute = observer(() => {
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const matches = useMatches();

  const currentMatch = matches[matches.length - 1];
  const isProtectedRoute = (currentMatch?.handle as { protected: boolean })?.protected || false;


  const idToken = getCookie("id_token")
  const currentSession = getCookie("current_session");
  if (idToken) {
    authStore.authenticatedUser = new User(
      idToken,
      currentSession || "",
      "",
      new Date().getTime().toString()
    );
  } else {
    if (currentSession) {
      authService.refreshToken().then(() => {
        const idToken = getCookie("id_token")
        const currentSession = getCookie("current_session");
        if (idToken) {
          authStore.authenticatedUser = new User(
            idToken,
            currentSession || "",
            "",
            new Date().getTime().toString()
          );
        }
      });
    }
  }

  useEffect(() => {
    const redirectParam = urlParams.get("redirectTo") || "";
    interactionStore.redirectTo = redirectParam;

    if (authStore.isAuthenticated && location.pathname === routes.pages.login) {
      interactionStore.navigate = interactionStore.redirectTo || routes.pages.profile;
    }

    setIsAuthChecked(true);
  }, [authStore.isAuthenticated, urlParams]);

  if (isProtectedRoute && !authStore.isAuthenticated) {
    interactionStore.navigate = routes.pages.login;
    console.log("BrowserRoute: Redirecting to login due to unauthenticated access to protected route.");
  }

  // Show loading until auth check is complete
  if (!isAuthChecked) {
    return <BusyIndicator />;
  }



  return (
    <>
      <NavigationHandler />
      <BusyIndicator />
      <Outlet />

    </>
  );
});

export const browserRoutes = () => [
  {
    path: routes.root,
    element: <BrowserRoute />,
    errorElement: <Err404 />,
    children: [
      {
        path: routes.pages.login,
        element: <Login />,
        index: true,
        handle: { protected: false }

      },
      {
        path: "/profile",
        element: <Profile />,
        handle: { protected: true }
      },
      {
        path: routes.pages.signup,
        element: <Signup />,
        handle: { protected: false }

      },
      {
        path: routes.pages.resetPassword,
        element: <ResetPassword />,
        handle: { protected: false }
      },
      {
        path: routes.pages.createNewPassword,
        element: <CreateNewPassword />,
        handle: { protected: false }
      },
    ],
  },
];
